import './SelectInput.css';

import { cnCanary } from '##/utils/bem';

export const cnSelectInput = cnCanary('SelectInput');
